export const SECONDS_BEFORE_START = 3;
